module.exports = __webpack_public_path__ + "img/8.66f62826.jpg";